// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"136":"ce41b9ac","765":"57277232","967":"4e10cd6a"}[chunkId] + ".css";
};